import axios from "axios";

export const state = {
  expiringSoonCount: [],
};

export const getters = {
  expiringSoonCount: (state) => state.expiringSoonCount,
};

export const mutations = {
  setExpiringSoonCount(state, newValue) {
    state.expiringSoonCount = newValue;
  },
};

export const actions = {
  fetchExpiringSoonCount({ commit }) {
    axios.get("/drugs-to-expire").then((res) => {
      commit("setExpiringSoonCount", res.data.expiringSoonCount);
    });
  },
};
